import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isLoading: false,
	ConfirmRegisterResponse: {},
};

const ConfirmRegisterSlice = createSlice({
	name: "ConfirmRegister",
	initialState,
	reducers: {
		requestPending: state => {
			state.isloading = true;
		},
		ConfirmRegisterSuccess: (state, { payload }) => {
			state.isLoading = false;
			state.ConfirmRegisterResponse = payload || {};
		},
		requestFail: (state, { payload }) => {
			state.isLoading = false;
			state.COnfirmRegisterResponse = payload || {};
		},
	},
});
const { reducer, actions } = ConfirmRegisterSlice;
export const { requestPending, ConfirmRegisterSuccess, requestFail } = actions;
export default reducer;
